import { arrayOf, number, string, bool, shape, node, func } from 'prop-types';

// Namespace
export const namespace = 'ui-pdp-chart';

// Bar
export const barPropTypes = {
  className: string,
  height: number,
  width: string,
};

// Line
export const linePropTypes = {
  className: string,
};

// Space
export const spacePropTypes = {
  className: string,
};

// Tooltip Hover
export const tooltipHoverPropTypes = {
  className: string,
  children: node,
  hoverInfo: shape({
    body: shape({}),
    action: shape({}),
  }),
  isVisible: bool,
  onOpen: func,
  onClose: func,
};

// Bars Container
export const barsContainerPropTypes = {
  barsContainerNamespace: string,
  barsHeight: arrayOf(number),
  barsHoverInfo: arrayOf(shape({})),
  padding: number,
};

// Flag
export const flagPropTypes = {
  tooltipNamespace: string,
  valueClassName: string,
  lineClassName: string,
  poleSize: string,
  tooltipPosition: shape({ position: number, valuePosition: number, visible: bool }),
  tooltipValue: shape({
    text: string,
    color: string,
    bg_color: string,
    font_size: string,
    font_family: string,
  }),
  icon: shape({
    id: string,
    color: string,
  }),
};

// Limits Container
export const limitsContainerPropTypes = {
  limitsNamespace: string,
  lowerBand: string,
  middleBand: string,
  upperBand: string,
};

// Chart
export const chartPropTypes = {
  pricesDistribution: arrayOf(number),
  barsHoverInfo: arrayOf(shape({})),
  lowerBand: string,
  upperBand: string,
  middleBand: string,
  tooltip: shape({
    data: shape({
      text: string,
      color: string,
      bg_color: string,
      font_size: string,
      font_family: string,
    }),
    icon: shape({
      id: string,
      color: string,
    }),
    percentile_position: number,
  }),
  tooltipFipe: shape({
    data: shape({
      text: string,
      color: string,
      bg_color: string,
      font_size: string,
      font_family: string,
    }),
    percentile_position: number,
  }),
  padding: number,
  spaceBetweenBars: number,
};
